import { INonprofitProfile } from '../../../models/interfaces/nonprofitProfile/iNonprofitProfile';
import { NonprofitProfile } from '../../../models/classes/nonprofitProfile/nonprofitProfile';
import { PriorityLevel } from '../../../models/classes/nonprofitProfile/priorityLevel';

export default class State {
  orgKey: string = "";

  priorityLevelData: PriorityLevel[] = [];

  public profile: INonprofitProfile = new NonprofitProfile(); 
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/nonprofit/state.ts